<!--
 * @Author: wsx
 * @Date: 2022-02-25 15:11:46
 * @LastEditTime: 2022-02-28 10:50:38
 * @Description: 首頁右侧面板
 * @FilePath: \hz-digital-twin\src\views\Home\RightFrame.vue
-->
<template>
  <h-frame
    class="RightFrame"
    body-class="frame-content"
    type="right"
    :isShowOpenBtn="false"
  >
    <h-card title="研判预警">
      <div class="h-data-distribution">
        <div class="h-data-total" ref="carbonEmissionRef"></div>
        <ul class="h-data-detail">
          <li class="h-num-item">
            <span class="h-value">
              <span class="h-value-molecule">160</span>
              <!-- <span class="h-value-denominator">/23</span> -->
            </span>
            <span class="h-label">今日预警</span>
          </li>
          <li class="h-num-item">
            <span class="h-value">
              <span class="h-value-molecule">105</span>
              <!-- <span class="h-value-denominator">/23</span> -->
            </span>
            <span class="h-label">人员</span>
          </li>
          <li class="h-num-item">
            <span class="h-value">
              <span class="h-value-molecule">55</span>
              <!-- <span class="h-value-denominator">/23</span> -->
            </span>
            <span class="h-label">车辆</span>
          </li>
        </ul>
      </div>
    </h-card>
    <h-card class="energyConsumption" title="能耗动态">
      <div
        class="h-data-areaSafety"
        ref="areaSafetyEcharts"
        id="areaSafetyEchart"
      ></div>
      <!-- <ul class="energyConsumption-content">
        <li class="h-item">
          <div class="h-item-icon">
            <h-icon icon="icon-shandian" font-size="30"></h-icon>
          </div>
          <div class="h-item-detail">
            <div class="h-detail-label">本月累计用电总数（kwh）</div>
            <div class="h-detail-value">23234.23</div>
          </div>
        </li>
        <li class="h-item">
          <div class="h-item-icon">
            <h-icon icon="icon-shui" font-size="30"></h-icon>
          </div>
          <div class="h-item-detail">
            <div class="h-detail-label">本月累计用水总数（t）</div>
            <div class="h-detail-value">23234.23</div>
          </div>
        </li>
        <li class="h-item">
          <div class="h-item-icon">
            <h-icon icon="icon-ranqi" font-size="30"></h-icon>
          </div>
          <div class="h-item-detail">
            <div class="h-detail-label">本月累计用气总数（m²）</div>
            <div class="h-detail-value">23234.23</div>
          </div>
        </li>
      </ul> -->
    </h-card>
    <h-card class="equipmenUse" title="设备设施可用率">
      <!-- <ul class="h-deviceStatus">
        <li class="h-deviceStatus-item">
          <div class="h-ratio">23%</div>
          <div class="h-label">
            <span>正常</span>
            <span class="h-val">223</span>
          </div>
        </li>
        <li class="h-deviceStatus-item">
          <div class="h-ratio">23%</div>
          <div class="h-label">
            <span>故障</span>
            <span class="h-val">223</span>
          </div>
        </li>
        <li class="h-deviceStatus-item">
          <div class="h-ratio">23%</div>
          <div class="h-label">
            <span>检修</span>
            <span class="h-val">223</span>
          </div>
        </li>
      </ul> -->
      <div class="eareItem" v-for="(item, index) in eareInfoList" :key="index">
        <div
          class="eareItemImg"
          @mouseover="handleMoreOperation(item)"
          @mouseleave="handleMoreLeave(item)"
        >
          <el-image
            :src="item.url"
            :preview-src-list="srcList"
            :initial-index="4"
            fit="cover"
          >
          </el-image>
          <!-- <div class="downBtn" v-show="!moreFalse">下载</div> -->
          <div class="moreBtn" @click="moreClick">
            <!-- 更多操作 -->
            <i
              :class="['iconfont', 'icon-zhuangbei']"
              v-show="item.value == showEareItem && moreOperation"
            ></i>
            <div
              class="moreSelect"
              v-show="item.value == showEareItem && moreFalse"
            >
              <div
                class="moreList"
                v-for="(it, ind) in moreSelectList"
                :key="ind"
              >
                <i :class="['iconfont', it.icon]"></i>
                {{ it.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="eareFont">
          <div class="bluebg"></div>
          {{ item.name }}
        </div>
      </div>
    </h-card>
  </h-frame>
</template>
<script>
import { defineComponent, reactive, onMounted, toRefs, ref } from "vue";
import * as echarts from "echarts";
import { carbonEmission, areaSafety } from "./echart";
export default defineComponent({
  name: "RightFrame",
  components: {},
  setup(props) {
    const state = reactive({
      eareInfoList: [
        // { name: "涉黄整治", value: "1", url: require("./ren1.jpg") },
        // { name: "涉毒抓拍", value: "2", url: require("./ren1.jpg") },
        // { name: "追逃布控", value: "3", url: require("./ren2.jpg") }
      ],
      moreSelectList: [
        { name: "查看大图", icon: "icon-fangda", path: "", value: "1" },
        { name: "下载", value: "icon-shexiangtou1", path: "" },
        { name: "身份稽查", value: "icon-shenfenzheng", path: "" },
        { name: "落脚点分析", value: "icon-navigation_e", path: "" },
        { name: "人员详情", value: "icon-paixu", path: "" },
        { name: "视图研判", value: "icon-yanpanmoxing", path: "" },
        { name: "同行分析", value: "icon-bansuitongxi", path: "" },
        { name: "抓拍检索", value: "icon-biaoshilei_luxiang", path: "" },
        { name: "1比1比对", value: "icon-beijingyibiyi", path: "" },
      ],
      showEareItem: "1",
      moreFalse: false,
      defaultOpen: true,
      moreOperation: false, // 展示更多操作
    });
    const refData = toRefs(state);
    const carbonEmissionRef = ref();
    const areaSafetyRef = ref();
    // 重点人员统计
    const myareaSafetyEchart = () => {
      // 区域安全图
      const areaChart = echarts.init(
        document.getElementById("areaSafetyEchart")
      );
      areaChart.setOption(areaSafety());
      return areaChart;
    };
    const handleMoreOperation = (item) => {
      state.moreOperation = true;
      state.showEareItem = item.value;
    };
    const moreClick = () => {
      state.moreFalse = !state.moreFalse;
    };
    const handleMoreLeave = () => {
      state.moreOperation = false;
      state.moreFalse = false;
    };
    onMounted(() => {
      // 碳排放统计图
      const chart = echarts.init(carbonEmissionRef.value);
      chart.setOption(carbonEmission());
      const areaChart = myareaSafetyEchart();
      window.addEventListener("resize", () => {
        areaChart.resize();
      });
    });
    return {
      ...refData,
      carbonEmissionRef,
      areaSafetyRef,
      handleMoreOperation,
      handleMoreLeave,
      moreClick,
    };
  },
});
</script>
<style lang="scss" scoped>
@import "@/assets/utils.scss";
.RightFrame {
  .HCard {
    background-color: #0000;
    /deep/.HTitle {
      color: #cb8847;
    }
    /deep/.h-card-body {
      width: 100%;
      display: flex;
      margin: 10px 0 0 0;
      overflow: visible;
      justify-content: space-evenly;
    }
    .eareItem {
      display: flex;
      flex-direction: column;
      font-size: 16px;
      color: #fff;
      .eareItemImg {
        position: relative;
        width: 100px;
        height: 100px;
        .el-image {
          width: 100%;
          height: 100%;
          cursor: pointer;
        }
        .downBtn {
          padding: 3px 5px;
          background: rgba(0, 0, 0, 0.5);
          // border-radius: 5px;
          position: absolute;
          width: 100%;
          top: 0;
          text-align: center;
          cursor: pointer;
        }
        .moreBtn {
          position: absolute;
          width: 100%;
          text-align: center;
          background: rgba(0, 0, 0, 0.5);
          bottom: 0px;
          cursor: pointer;
        }
      }

      .eareFont {
        display: flex;
        align-items: center;
        margin-top: 6px;
        .bluebg {
          width: 5px;
          height: 5px;
          margin-right: 10px;
          background-color: #73f1f3;
        }
      }
    }
  }
  :deep(.frame-content) {
    display: flex;
    flex-direction: column;
  }
  .h-data-distribution {
    height: 110px;
    width: 100%;
    @include flex-row-c-c;
    .h-data-total {
      width: 30%;
      height: 100%;
    }
    .h-data-detail {
      flex: 1;
      height: 100%;
      @include flex-row-sa-c;
      .h-num-item {
        @include flex-col-s-c;
        $colors: #e0cb5d, #62bfeb, #fe7c41;
        @each $color in $colors {
          $i: index($colors, $color);
          &:nth-child(#{$i}) {
            color: $color;
            .h-value {
              border-bottom: 1px solid $color;
            }
          }
        }
        .h-value {
          font-size: 24px;
          line-height: 36px;
          font-family: "YouSheBiaoTiHei";
          .h-value-molecule {
            font-size: 36px;
          }
        }
        .h-label {
          font-size: 16px;
          margin-top: 8px;
          font-weight: 600;
        }
      }
    }
  }
  .energyConsumption {
    .h-data-areaSafety {
      width: 100%;
      height: 200px;
    }
    // flex: 1;
    .energyConsumption-content {
      height: 100%;
      margin-top: 8px;
      margin-bottom: 8px;
      @include flex-col-sa-s;
      $list: #ffc96a, #00a1e0, #23e6d1;
      @each $color in $list {
        .h-item {
          width: 100%;
          @include flex-row-s-c;
          .h-item-icon {
            width: 62px;
            height: 62px;
            background-size: 100% 100%;
            @include flex-row-c-c;
            &::after {
              content: "";
              width: 100%;
              height: 100%;
              position: absolute;
              top: 0;
              left: 0;
              z-index: 0;
              @include rotate;
            }
          }
          .h-item-detail {
            flex: 1;
            height: 100%;
            margin: 0 10px;
            background-size: 100% auto;
            background-repeat: no-repeat;
            background-position-y: bottom;
            position: relative;
            box-sizing: border-box;
            padding-top: 10px;
            padding-left: 30px;
            @include flex-row-s-c;
            .h-detail-label {
              font-size: 16px;
              position: absolute;
              top: -5px;
              left: 20px;
            }
            .h-detail-value {
              font-size: 26px;
            }
          }
        }
        $i: index($list, $color);
        .h-item:nth-child(#{$i}) {
          .h-item-icon {
            color: $color;
            position: relative;
            z-index: 1;
            &::after {
              background-image: url("~@/assets/images/index/iconBg#{$i}.png");
            }
          }
          .h-item-detail {
            background-image: url("~@/assets/images/index/valBg#{$i}.png");
          }
        }
      }
    }
  }
  .h-deviceStatus {
    @include flex-row-se-c;
    .h-deviceStatus-item {
      @include flex-col-c-c;
      .h-ratio {
        width: 77px;
        height: 77px;
        background-size: 100% 100%;
        font-size: 20px;
        margin: 10px 0;
        position: relative;
        z-index: 1;
        @include flex-col-c-c;
        &::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 0;
          @include rotate(6s);
        }
      }
      .h-label {
        font-size: 16px;
        .h-val {
          margin-left: 5px;
        }
      }
      $colors: #22deca, #e34824, #85e623;
      @each $c in $colors {
        $i: index($colors, $c);
        &:nth-child(#{$i}) {
          color: $c;
          .h-ratio::after {
            background-image: url("~@/assets/images/index/#{$i}.png");
          }
        }
      }
    }
  }
  .moreSelect {
    position: absolute;
    overflow: visible;
    font-size: 14px;
    bottom: 21px;
    background: rgba(0, 0, 0, 1);
    width: 100%;
    // border-radius: 4px;
    line-height: 28px;
    cursor: pointer;
  }
  .equipmenUse {
    overflow: visible;
  }
}
</style>
